import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu, MenuItem } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';
import useUserRole from '../activeUser';

const adminMenuItems = [
  { key: 'commonCode', to: '/admin/commonCode', label: 'Vendor Master' },
  { key: 'stockMaster', to: '/admin/stockMaster', label: 'Stock Master' },
  { key: 'defaultLedger', to: '/admin/defaultLedger', label: 'Default Ledger' },
  { key: 'userMapping', to: '/admin/userMapping', label: 'User Mapping' },
  { key: 'companyMaster', to: '/admin/companyMaster', label: 'Company Master' },
];

const superAdminMenuItems = [
  { key: 'manageTenants', to: '/super-admin/manageTenants', label: 'Manage Tenants' },
  { key: 'usageReport', to: '/super-admin/usage-report', label: 'Usage Report' },
];

const AdminNav = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const userRole = useUserRole();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = userRole === 'SuperAdmin' ? superAdminMenuItems : adminMenuItems;

  const adminDropdownLabel = userRole === 'SuperAdmin' ? 'Super Admin' : 'Admin';

  return (
    <>
      <Button
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          color: 'black',
          fontFamily: 'inherit',
          backgroundColor: '#d1d5db',
          ':hover': {
            backgroundColor: '#9ca3af',
          },
        }}
        variant='contained'
        endIcon={<KeyboardArrowDownIcon />}
        disableElevation
      >
        {adminDropdownLabel}
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.key}
            component={Link}
            to={item.to}
            onClick={handleClose}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default AdminNav;
